/** Standard search debounce delay (ms) for BackOffice manage/list pages. */
export const MANAGE_PAGE_SEARCH_DEBOUNCE_MS = 1000;
